import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Card, Container } from 'react-bootstrap';
import Sidebar from './Sidebar';
import configAdmin from './configAdmin.json';
import { getPageContent, updatePageContent } from './apiCalls';
import ToastConfirmation from './ToastConfirmation';

const { MOBILITYPAGE_CODE } = configAdmin

export default function MobilityEdit() {
  const [showToaster, setShowToaster] = useState(false);
  const [pageContent, setPageContent] = useState({});
  const [pageContentFormData, setPageConentFormData] = useState({});

  useEffect(() => {
      getPageContent(setPageContent, MOBILITYPAGE_CODE);
  }, []);

  const submitForm = () => {
    const mainConfigformDataSubmit = {
      ...pageContent,
      ...pageContentFormData
    }

    updatePageContent(mainConfigformDataSubmit, MOBILITYPAGE_CODE);
    setShowToaster(true);
  };

  const formContent = (
    <Form>
      <Form.Group className="admin-content-group">
      <Form.Label className="admin-content-form-label">Titulo</Form.Label>
      <Form.Control
          placeholder="Titulo"
          defaultValue={ pageContent?.title && pageContent.title }
          onChange={ (e) => {
            setPageConentFormData({
                ...pageContentFormData,
                title: e.target.value
            });
          } }  
        />
      </Form.Group>

      <Form.Group className="admin-content-group">
        <Form.Label className="admin-content-form-label">Contenido</Form.Label>
        <Form.Control
          as="textarea"
          rows={10}
          defaultValue={ pageContent?.content && pageContent.content }
          onChange={ (e) => {
            setPageConentFormData({
                ...pageContentFormData,
                content: e.target.value
            });
            } } 
        />
      </Form.Group>

      <Button _type="submit" className="odisea-form-button-submit" onClick={() => {submitForm();}}>Guardar</Button>

    </Form>
  )

  return (
    <Container fluid>
      <Row>
          <Col xs={2} >
            <Sidebar />
          </Col>
          <Col xs={10} className="admin-content">
            <ToastConfirmation showToaster={showToaster} setShowToaster={ setShowToaster } message={ 'Contenido guardado con éxito!' }/>
            <Card>
              <Card.Header> Contenido de movilidad </Card.Header>
              <Card.Body>{ formContent }</Card.Body>
            </Card>
          </Col> 
      </Row>
    </Container>
  )
}
